// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c2467a5b","455":"e500a338","551":"d254cff7","707":"736837a8","828":"49104f39","885":"e9440c31"}[chunkId] + ".chunk.js";
};